<script lang="ts" setup>
const auth = useAuth()

const ticker = computed(() => auth.project?.ticker?.toUpperCase() || auth.project?.name || 'your token')
const isPreTge = computed(() => !auth.project?.tokenListed)

const hero = computed(() =>
  isPreTge.value
    ? { title: `Prepare for ${ticker.value}'s Launch`, description: 'Your control room to plan & execute your TGE plan.' }
    : { title: `Optimize Post-TGE Growth for ${ticker.value}`, description: 'Monitor performance & refine your growth strategy.' },
)
</script>

<template>
  <div class="divide-y divide-default">
    <div class="mx-auto flex w-full max-w-350 flex-col gap-10 px-4 pt-6 pb-10 md:px-5">
      <div class="@container flex flex-col gap-5 md:gap-4">
        <section id="hero" class="grid grid-cols-1 gap-5 @6xl:grid-cols-3">
          <div class="flex flex-col justify-center gap-1">
            <h1 class="text-xl font-semibold text-primal">
              {{ hero.title }}
            </h1>
            <p class="text-sm text-secondary">
              {{ hero.description }}
            </p>
          </div>

          <HomeHeroStats :listed="!isPreTge" class="@6xl:col-span-2" />
        </section>

        <section class="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div id="summary-intelligence-cards" class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-2">
            <PrOverviewTokenomicsCard />
            <PrOverviewExchangeListingsCard />
            <PrOverviewMmLeaderboardSummaryCard id="mm-leaderboard-summary" class="sm:col-span-2" />
          </div>
          <HomeExploreToolsPanel class="lg:col-span-1" />
        </section>

        <CoreFullServiceAdvisoryBanner />
      </div>

      <template v-if="isPreTge">
        <PrOverviewTokenomicsIntelligenceSection id="tokenomics-intelligence" />
        <CoreTokenomicsPromoBanner class="mb-4" />
      </template>

      <div class="flex flex-col gap-4">
        <PrOverviewMmIntelligenceSection id="mm-intelligence" />
        <PrOverviewBestPerformersStrip />
        <CoreMarketMakerPromoBanner class="mb-4" />
      </div>

      <template v-if="!isPreTge">
        <PrOverviewMmMonitoringSection id="mm-monitoring" />
        <CoreMonitoringPromoBanner class="mb-4" />
      </template>

      <PrOverviewExchangeIntelligenceSection id="exchange-intelligence" />
      <CoreExchangePromoBanner class="mb-4" />

      <hr class="mb-4 border-default">

      <CoreAcademyStrip />
    </div>

    <PrOverviewFaqSection class="mx-auto w-full max-w-350 px-4 pt-8 pb-12 md:px-10" />
  </div>
</template>
